import AdminsPage from './Admins.page';

export default AdminsPage;
